<template>
    <div class="w-100 mb-5" :style="{background: background}">
        <div class="position-relative shape shape-top shape-fluid-x svg-shim text-white">
        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg" style="    transform: scale(2) rotate(180deg);transform-origin: 50% 32%;">
            <path d="M0 48h2880V0h-720C1442.5 52 720 0 720 0H0v48z" fill="#fff" />
        </svg>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        background: {}
    }
}
</script>